/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ServiceDocumentStructure } from './service-document-structure';

/**
 * 
 * @export
 * @interface Service
 */
export interface Service {
    /**
     * 
     * @type {number}
     * @memberof Service
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'target'?: ServiceTargetEnum;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'type'?: ServiceTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Service
     */
    'necessaryData'?: Array<ServiceNecessaryDataEnum>;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof Service
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'freeBlock'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof Service
     */
    'category'?: number;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'beneficiaries'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'advantages'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'requisites'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'messageFinalized'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'requiredDocumentsText'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'issue'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'shortDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'functionNameService'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'publicationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'additionalQuestionnaireName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'requisitesQuestionnaireName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'familyMemberFieldName'?: string;
    /**
     * 
     * @type {number}
     * @memberof Service
     */
    'itemsAvailablePerOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Service
     */
    'available'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Service
     */
    'order'?: number;
    /**
     * 
     * @type {Array<ServiceDocumentStructure>}
     * @memberof Service
     */
    'applicantDocuments'?: Array<ServiceDocumentStructure>;
    /**
     * 
     * @type {Array<ServiceDocumentStructure>}
     * @memberof Service
     */
    'familyDocuments'?: Array<ServiceDocumentStructure>;
    /**
     * 
     * @type {Array<ServiceDocumentStructure>}
     * @memberof Service
     */
    'familyMemberDocuments'?: Array<ServiceDocumentStructure>;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Service
     */
    'updated_at'?: string;
}

export const ServiceTargetEnum = {
    Personal: 'personal',
    Family: 'family'
} as const;

export type ServiceTargetEnum = typeof ServiceTargetEnum[keyof typeof ServiceTargetEnum];
export const ServiceTypeEnum = {
    Accessory: 'accessory',
    Bonus: 'bonus',
    Info: 'info'
} as const;

export type ServiceTypeEnum = typeof ServiceTypeEnum[keyof typeof ServiceTypeEnum];
export const ServiceNecessaryDataEnum = {
    PersonalData: 'personal_data',
    FamilyData: 'family_data',
    FullQuestionnaire: 'full_questionnaire',
    CitizenshipQuestionnaire: 'citizenship_questionnaire',
    FamilyQuestionnaire: 'family_questionnaire',
    IncomeQuestionnaire: 'income_questionnaire',
    HeritageQuestionnaire: 'heritage_questionnaire'
} as const;

export type ServiceNecessaryDataEnum = typeof ServiceNecessaryDataEnum[keyof typeof ServiceNecessaryDataEnum];


